import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { Http } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";
import useHandleConnected from "./useHandleConnected";

const METHOD_COLORS = {
  GET: "#4caf50",
  POST: "#2196f3",
  PUT: "#ff9800",
  DELETE: "#f44336",
};

const HttpRequestNode = memo(({ id, data, isConnectable, selected }) => {
  const getHandleClass = useHandleConnected(id);
  const method = data?.method || "GET";
  const url = data?.url || "";
  const saveVars = data?.saveVariables;
  const varCount = Array.isArray(saveVars) ? saveVars.length : 0;

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Http />}
      title="Requisicao HTTP"
      color="#0277BD"
      bgColor="#E1F5FE"
      noTarget
      noSource
      isConnectable={isConnectable}
      selected={selected}
      minWidth={220}
    >
      {/* Custom target handle */}
      <Handle
        type="target"
        position={Position.Left}
        id="httpRequest-in"
        className={getHandleClass("target", "httpRequest-in")}
        style={{ cursor: "crosshair" }}
        isConnectable={isConnectable}
      />

      {/* Method + URL row */}
      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
        <span
          style={{
            fontSize: 10,
            fontWeight: 800,
            color: "#fff",
            backgroundColor: METHOD_COLORS[method] || "#666",
            padding: "2px 8px",
            borderRadius: 4,
            letterSpacing: "0.04em",
            flexShrink: 0,
          }}
        >
          {method}
        </span>
        <span
          style={{
            fontSize: 10,
            color: "#37474F",
            fontFamily: "'JetBrains Mono', 'Fira Code', 'Consolas', monospace",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            flex: 1,
            maxWidth: 150,
          }}
        >
          {url || "URL nao definida"}
        </span>
      </div>

      {/* Variable count */}
      {varCount > 0 && (
        <div
          style={{
            fontSize: 10,
            color: "#0277BD",
            display: "flex",
            alignItems: "center",
            gap: 4,
          }}
        >
          <span
            style={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              backgroundColor: "#0277BD",
              display: "inline-block",
            }}
          />
          {varCount} variave{varCount === 1 ? "l" : "is"} salva{varCount === 1 ? "" : "s"}
        </div>
      )}

      {/* Preset */}
      {data?.presetName && (
        <div style={{ fontSize: 9, color: "#78909C", marginTop: 2 }}>
          Preset: {data.presetName}
        </div>
      )}

      {/* Retry info */}
      {data?.retryCount > 0 && (
        <div style={{ fontSize: 9, color: "#F57C00", marginTop: 2 }}>
          Retry: {data.retryCount}x (cada {data.retryDelay || 2000}ms)
        </div>
      )}

      {/* Labels das saídas */}
      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 6 }}>
        <div style={{ display: "flex", justifyContent: "flex-end", paddingRight: 4 }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#4caf50", borderRadius: 4,
            padding: "2px 8px", letterSpacing: "0.04em",
          }}>
            OK
          </span>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", paddingRight: 4 }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#ef5350", borderRadius: 4,
            padding: "2px 8px", letterSpacing: "0.04em",
          }}>
            ERRO
          </span>
        </div>
      </div>

      {/* Source handles: sucesso (a) e erro (b) */}
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        className={getHandleClass("source", "a")}
        style={{ cursor: "crosshair", top: "60%" }}
        isConnectable={isConnectable}
      />
      <Handle
        type="source"
        position={Position.Right}
        id="b"
        className={getHandleClass("source", "b")}
        style={{ cursor: "crosshair", top: "85%" }}
        isConnectable={isConnectable}
      />
    </NodeWrapper>
  );
});

HttpRequestNode.displayName = "HttpRequestNode";
export default HttpRequestNode;
